import { FC } from "react";
import styled from "styled-components";

export interface SystemEventProps {
  text: string;
  description: string;
}

const Container = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${theme.space[4]} 0`,
    textAlign: "center",
  };
});

const Message = styled.div(({ theme }) => {
  return {
    fontSize: theme.fontSizes[1],
    lineHeight: theme.lineHeights[1],
    color: theme.colors.black,
  };
});

const Description = styled.div(({ theme }) => {
  return {
    color: theme.colors.grayDark,
    fontSize: 12,
    lineHeight: "17px",
  };
});

export const SystemEvent: FC<SystemEventProps> = ({ text, description }) => {
  return (
    <Container>
      <Message>{text}</Message>
      <Description>{description}</Description>
    </Container>
  );
};
